import { Factory } from 'rosie';

Factory.define('FbUserProfile');

Factory.define('FbUserProfileWithDefaults')
  .extend('FbUserProfile')
  .attr('firstName', 'Martha')
  .attr('gender', 'female')
  .attr('lastName', 'Williams')
  .attr('profilePic', '/images/demo/martha.jpg')
  .attr('timezone', -8);



// WEBPACK FOOTER //
// ./factories/customer_profile/fb_user_profile_factory.js